<style>
  .mainBackground1{
    background-image: url(../../../assets/Content/Login/main/1.jpg);background-size: cover;
  }
  .mainBackground2{
    background-image: url(../../../assets/Content/Login/main/2.jpg);background-size: cover;
  }
  .mainBackground3{
    background-image: url(../../../assets/Content/Login/main/3.jpg);background-size: cover;
  }
  .mainBackground4{
    background-image: url(../../../assets/Content/Login/main/4.jpg);background-size: cover;
  }
  .mainBackground5{
    background-image: url(../../../assets/Content/Login/main/5.jpg);background-size: cover;
  }
  .mainBackground6{
    background-image: url(../../../assets/Content/Login/main/6.jpg);background-size: cover;
  }
</style>


<section class="lockscreen height-100vh page-section-ptb parallax"
[ngClass]="{'mainBackground1': MainBackground===1,
'mainBackground2': MainBackground===2,
'mainBackground3': MainBackground===3,
'mainBackground4': MainBackground===4,
'mainBackground5': MainBackground===5,
'mainBackground6': MainBackground===6
}">
  <div class="container h-100">
    <div class="row justify-content-center h-100">
      <div class="col-lg-5 col-md-8 col-sm-8 align-self-center">
        <div class="card text-center pb-40 bg-white pl-5 pr-5 clearfix">
          <div class="user-info">
            <h2>تغییر رمز عبور</h2>
          </div>
          <div class="user-info">
            <img src="{{BaserUrlImage}}" alt="">
            <h6 class="name">{{Fullname}}</h6>
          </div>
          <form [formGroup]="ValidationUser" (submit)="SubmitValidationUser()">
            <div class="form-group mb-20">
              <input class="form-control" formControlName="Phone" type="number" placeholder="شماره همراه خود را وارد نمائید">
              <small *ngIf="!get_Form_Phone().valid && get_Form_Phone().touched"
                class="form-text text-muted MyErrorRedColor">شماره همراه را وارد نمائید.</small>

              <div class="clear">
                <button type="button" title="Unlock Account" name="submitbtn" class="button lockscreen-button"> <i
                    class="fa fa-phone"></i> </button>
              </div>
            </div>
            <div class="form-group mb-20" *ngIf="SecondCounter<0">
              <button type="button" (click)="SendValidationCode()" [disabled]="!get_Form_Phone().valid" style="background: #08c;color: white;font-weight: bolder;"  name="submitbtn" class="btn btn-info form-control">  ارسال کد  </button>
            </div>
            <div class="form-group mb-20" *ngIf="SecondCounter>0">
              <button type="button"  style="background: #08c;color: white;font-weight: bolder;"  name="submitbtn" class="btn btn-info form-control">  ارسال مجدد کد تا {{SecondCounter}} ثانیه  </button>
            </div>

            <div class="form-group mb-20">
              <input formControlName="Password" class="form-control" type="text" placeholder="رمز عبور جدید را وارد نمائید">
              <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched"
                class="form-text text-muted MyErrorRedColor">رمز عبور جدید را وارد نمائید.</small>

              <div class="clear">
                <button type="button" title="Unlock Account" name="submitbtn" class="button lockscreen-button"> <i
                    class="fa fa-key"></i> </button>
              </div>
            </div>
            <div class="form-group mb-20">
              <input formControlName="RePassword" class="form-control" type="text" placeholder="تکرار رمز عبور جدید را وارد نمائید">
              <small *ngIf="!get_Form_RePassword().valid && get_Form_RePassword().touched"
                class="form-text text-muted MyErrorRedColor">تکرار رمز عبور جدید را وارد نمائید.</small>

              <div class="clear">
                <button type="button" title="Unlock Account" name="submitbtn" class="button lockscreen-button"> <i
                    class="fa fa-key"></i> </button>
              </div>
            </div>

            <div class="form-group mb-20">
              <input class="form-control" formControlName="Code" type="text" placeholder="کد ارسال شده را وارد نمائید">
              <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched"
              class="form-text text-muted MyErrorRedColor">کد ارسال شده را وارد نمائید.</small>

              <div class="clear">
                <button type="button" title="Unlock Account" name="submitbtn" class="button lockscreen-button"> <i
                    class="fa fa-file-text"></i> </button>
              </div>
            </div>

            <div class="form-group mb-20">
              <button type="submit"  [disabled]="!ValidationUser.valid" style="background: #08c;color: white;font-weight: bolder;"  name="submitbtn" class="btn btn-info form-control">  ثبت اطلاعات </button>
            </div>


          </form>

        </div>
      </div>
    </div>
  </div>
</section>
